import {
  Divider,
  Typography,
  Input,
  Button,
  notification,
  Modal,
  DatePicker,
} from "antd";
import { ColumnProps } from "antd/lib/table";
import React, { Fragment, useState } from "react";
import { titles } from "../../setup/messages";
import PaginatedList from "../list/PaginatedList";
import { IUser } from "./models/IUser";

import axios from "axios";
import moment from "moment";
import dayjs from "dayjs";
import {formatDateWithTimezoneOffset} from "../../lib/lib";
import StableDatePicker from "../common/StableDatePicker";
const { Search } = Input;
const { RangePicker } = DatePicker;

const UsersPage: React.FC = () => {
  const endpoint = `/api/users/team`;
  const endpointremove = `/api/users/delete`;
  const endpointupdate = `/api/users/update`;

  // State for search query
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState<IUser | null>(null);

  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const adjustedfirstDayOfMonth = formatDateWithTimezoneOffset(
    firstDayOfMonth,
    7
  );
  const adjustedlastDayOfMonth = formatDateWithTimezoneOffset(
    lastDayOfMonth,
    7
  );
  const [startDate, setStartDate] = useState<string | null>(
    adjustedfirstDayOfMonth
  );
  const [endDate, setEndDate] = useState<string | null>(adjustedlastDayOfMonth);

  const [formData, setFormData] = useState({
    id: "",
    realName: "",
    teamName: "",
    email: "",
    name: "",
  });

  const handleUpdate = (record: IUser) => {
    setFormData({
      realName: record.realName,
      teamName: record.teamName,
      email: record.email,
      id: record._id,
      name: record.name,
    });
    setCurrentUser(record);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns: Array<ColumnProps<IUser>> = [
    {
      dataIndex: "realName",
      key: "realName",
      title: "Name",
    },
    {
      dataIndex: "teamName",
      key: "teamName",
      title: "Team",
    },
    {
      dataIndex: "email",
      key: "email",
      title: "Email",
    },
    {
      dataIndex: "isAdmin",
      key: "isAdmin",
      title: "Admin",
      render: (isAdmin: boolean) => (isAdmin ? "Yes" : "No"),
    },
    {
      dataIndex: "kudosSpendable",
      key: "kudosSpendable",
      title: "Sao Có Thể Dùng",
      sorter: true,
    },
    {
      dataIndex: "kudosGiveable",
      key: "kudosGiveable",
      title: "Sao Có Thể Tặng",
      sorter: true,
    },
    {
      dataIndex: "kudosGranted",
      key: "kudosGranted",
      title: "Sao Đã Nhận",
      sorter: true,
    },
    {
      dataIndex: "totalKudosGiveValue",
      key: "totalKudosGiveValue",
      title: "Sao Đã Tặng",
      sorter: true,
    },
    {
      dataIndex: "giftCost",
      key: "giftCost",
      title: "Sao Quy Đổi",
      sorter: true,
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Action",
      render: (text: string, record: IUser) => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <Button onClick={() => handleUpdate(record)}>Sửa</Button>
          <Button
            onClick={() => handleRemove(record)}
            style={{ marginLeft: 10 }}
          >
            Xoá
          </Button>
        </span>
      ),
    },
  ];

  const handleRemove = (record: IUser) => {
    Modal.confirm({
      title: 'Bạn có muốn xoá user này không?',
      content: `User: ${record.realName}`,
      okText: 'Vâng',
      cancelText: 'Không',
      onOk: () => {
        axios.delete(`${endpointremove}/${record._id}`)
          .then(response => {
            if(response.data.status) {
              notification.success({
                message: 'Xoá user thành công',
                description: `User ${record.realName} đã được xoá`,
              });
            }
          })
          .catch(error => {
            notification.error({
              message: 'Có lỗi xảy ra',
              description: `Đã có lỗi xảy ra khi xoá user ${record.name}.`,
            });
          });
      },
      onCancel: () => { },
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await axios.post(endpointupdate, formData);
      if(response.data ) {
        notification.success({
          message: 'Update user thành công',
          description: `User ${currentUser?.userName} đã được cập nhật`,
        });
      }
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const handleDateChange = (dates: [dayjs.Dayjs, dayjs.Dayjs] | null, dateStrings: [string, string]) => {
    if (dates && dateStrings) {
      setStartDate(dateStrings[0]);
      const endDate = new Date(dateStrings[1]);
      endDate.setDate(endDate.getDate() + 1);
      const incrementedEndDateString = endDate.toISOString().split("T")[0];
      setEndDate(incrementedEndDateString);
    }
  };
  console.log("startDate", startDate);
  console.log("endDate", endDate);
  return (
    <Fragment>
              <Typography.Title level={2}>{titles.team}</Typography.Title>
      <Divider />
      <div style={{ 
        padding: '24px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
      }}>
        {/* Filter Section */}
        <div style={{ 
          display: 'flex',
          gap: '16px',
          marginBottom: '24px',
          flexWrap: 'wrap'
        }}>
          {/* Date Range Picker */}
          <div style={{ flex: '1', minWidth: '300px' }}>
            <div style={{ marginBottom: '8px' }}>
              <label style={{ 
                fontSize: '14px',
                fontWeight: 500,
                color: '#262626'
              }}>
                Khoảng Thời Gian
              </label>
            </div>
            <StableDatePicker
              style={{
                width: "100%",
                borderRadius: "6px"
              }}
              onChange={handleDateChange}
              defaultValue={[
                dayjs(adjustedfirstDayOfMonth),
                dayjs(adjustedlastDayOfMonth),
              ]}
              format="YYYY-MM-DD"
              allowClear={false}
              placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
            />
          </div>

          {/* Search Box */}
          <div style={{ flex: '1', minWidth: '300px' }}>
            <div style={{ marginBottom: '8px' }}>
              <label style={{ 
                fontSize: '14px',
                fontWeight: 500,
                color: '#262626'
              }}>
                Tìm Kiếm
              </label>
            </div>
            <Search
              placeholder="Nhập tên hoặc email..."
              onSearch={setSearchQuery}
              style={{ width: '100%' }}

              allowClear
              enterButton={
                <Button type="primary" style={{ height: '32px' }}>
                  Tìm kiếm
                </Button>
              }
            />
          </div>
        </div>

        {/* Table Section */}
        <PaginatedList<IUser>
          columns={columns}
          endpoint={endpoint}
          pageSize={10}
          searchQuery={searchQuery}
          startDate={startDate}
          endDate={endDate}
        />
      </div>

      {/* Modal Section */}
      <Modal
        title="Update User"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <form
          onSubmit={handleFormSubmit}
          className="ant-form ant-form-horizontal"
        >
          <div className="ant-form-item">
            <label htmlFor="realName" className="ant-form-item-label">
              <span className="ant-form-item-required">Real Name:</span>
            </label>
            <div className="ant-form-item-control">
              <input
                type="text"
                id="realName"
                name="realName"
                value={formData.realName}
                onChange={handleInputChange}
                className="ant-input"
              />
            </div>
          </div>
          <div className="ant-form-item">
            <label htmlFor="teamName" className="ant-form-item-label">
              <span className="ant-form-item-required">Team Name:</span>
            </label>
            <div className="ant-form-item-control">
              <input
                type="text"
                id="teamName"
                name="teamName"
                value={formData.teamName}
                onChange={handleInputChange}
                className="ant-input"
              />
            </div>
          </div>
          <div className="ant-form-item">
            <label htmlFor="email" className="ant-form-item-label">
              <span className="ant-form-item-required">Email:</span>
            </label>
            <div className="ant-form-item-control">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="ant-input"
              />
            </div>
          </div>
          <div className="ant-form-item">
            <label htmlFor="email" className="ant-form-item-label">
              <span className="ant-form-item-required">Name:</span>
            </label>
            <div className="ant-form-item-control">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="ant-input"
              />
            </div>
          </div>
          <div className="ant-form-item">
            <div className="ant-form-item-control">
              <button type="submit" className="ant-btn ant-btn-primary">
                Save
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </Fragment>
  );
};

export default UsersPage;
